import { render, staticRenderFns } from "./busquedaPaciente.vue?vue&type=template&id=26273d8b&scoped=true"
import script from "./busquedaPaciente.vue?vue&type=script&lang=js"
export * from "./busquedaPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26273d8b",
  null
  
)

export default component.exports